// Removed unused imports since team ID is no longer clickable

export const roleColumns = [
    {
      field: "teamId",
      headerName: "ID",
      width: 100,
      renderCell: ({ value }) => (
        <span>{value}</span>
      ),
    },
    {
      field: "teamName",
      headerName: "Team Name",
      flex: 1,
    },
    {
      field: "accesstype",
      headerName: "Access Type",
      flex: 1,
    },
];

export const getUserProfileDefaultValues = {
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    houseNumber: "",
    zipcode: "", // Fixed: was zipCode, should be zipcode
    city: "",
    country: "IN",
    language: "en", // Added missing language field
}